import * as Rx from "rxjs";
import $ from "jquery";

let DateChangedObservable = new Rx.Observable.fromEvent($("#dispatch_date"), "change");
export { DateChangedObservable };
